export const step = {
    namespaced: true,
    state: {
        currentStep: 'search',
        firmSaved: false,
    },
    mutations: {
        setStep(state, step) {
            state.currentStep = step
        },
        setFirmSaved(state, status) {
            state.firmSaved = status
        },
    },
    getters: {
        isFirmSaved(state) {
            return state.firmSaved
        },
    },
}
